import React from 'react'
import styled from 'styled-components'
import SMConst from 'frontend_core/dist/constants/sm-const'
import { userImagePath } from 'frontend_core/dist/helpers/image'
import { relativeTime } from 'frontend_core/dist/helpers/format'
import RestClient from 'frontend_core/dist/rest/client'
import Cookie from 'js-cookie'
import Spinner from 'components/shared/MaterialSpinner'

type PropTypes = {
  config: Object,
  currentUser: Object,
  notifications: Array<Object>,
  display: Number,
  isLoading: boolean,
  isLimit: boolean,
}

const JsEmpty = styled.div`
  margin: 15px;
  font-size: 12px;
  color: #ccc;
  font-weight: normal;
  min-height: 20vh;
  text-align: center;
`

class NotificationList extends React.Component {
  constructor(props: PropTypes) {
    super(props)
  }

  notificationDidClick(e, notification, url) {
    e.stopPropagation()
    e.preventDefault()

    const path = `1/users/${this.props.currentUser.username}/notifications/${
      notification.id
    }/read.json`
    const query = { per_page: 20 }

    RestClient.patchJson(path, query).then(data => {
      window.location = url
    })
  }

  render() {
    if (this.props.display === SMConst.Display.Loading) {
      return (
        <div>
          <h2 className="site-header__nav-baloon-title">お知らせ</h2>
          <JsEmpty>
            <Spinner />
          </JsEmpty>
        </div>
      )
    } else if (!this.props.notifications || !this.props.notifications.length) {
      return <p className="site-header__nav-baloon-nodata">通知はありません</p>
    }

    const rows = []
    for (
      let rowIndex = 0;
      rowIndex < this.props.notifications.length;
      rowIndex++
    ) {
      const notification = this.props.notifications[rowIndex]
      let className = 'site-header__nav-baloon-menu clearfix'
      if (!notification.readAt) className += ' is-new'

      let url = '#'
      if (notification.aboutType === 'Reservation') {
        let reservation = notification.about
        if (
          this.props.currentUser &&
          reservation.user.id === this.props.currentUser.id
        ) {
          if (
            notification.notificationType ===
            SMConst.NotificationType.MessageUpdated
          ) {
            url = '/dashboard/messages/' + reservation.uid
          } else {
            url = '/dashboard/reservations/' + reservation.uid
          }
        } else {
          if (
            notification.notificationType ===
            SMConst.NotificationType.MessageUpdated
          ) {
            url =
              '/owners/' +
              reservation.owner.username +
              '/dasyboard/messages/' +
              reservation.uid
          } else {
            url =
              '/owners/' +
              reservation.owner.username +
              '/dasyboard/reservations/' +
              reservation.uid
          }
        }
      } else if (notification.aboutType === 'Owner') {
        let owner = notification.about
        url = '/owners/' + owner.username + '/dashboard'
      } else if (notification.aboutType === 'Point') {
        url = '/dashboard/points/available_point_histories'
      } else if (notification.aboutType === 'PointReferral') {
        url = '/referrals'
      } else if (
        notification.notificationType ===
        SMConst.NotificationType.ServiceNotification
      ) {
        url = notification.link
      }

      let name
      if (
        notification.fromType === 'AdminUser' ||
        notification.fromType === 'ServiceAdmin'
      ) {
        name = i18n.t('spacemarket')
      } else if (notification.fromType === 'Owner') {
        name = notification.from.ownerName
      } else if (notification.fromType === 'User') {
        name = notification.from.contactName
      }

      rows.push(
        <li className={className} key={rowIndex}>
          <a
            onClick={e => this.notificationDidClick(e, notification, url)}
            href={url}
            data-tag={rowIndex}
            className="link-black link-borderless"
          >
            <p className="site-header__nav-baloon-message-content">
              {notification.content}
            </p>
            <div className="site-header__nav-baloon-message-name">
              <p>
                <img src={userImagePath(notification.from)} alt={name} />
              </p>
              <p>
                {name}
                <span>{relativeTime(notification.createdAt)}</span>
              </p>
            </div>
          </a>
        </li>,
      )
    }

    if (this.props.isLoading && !this.props.isLimit) {
      rows.push(
        <li key={rows.length} className="js-loading-row">
          {i18n.t('page.header.loading')}
        </li>,
      )
    }

    return (
      <div>
        <h2 className="site-header__nav-baloon-title">お知らせ</h2>
        <ul>{rows}</ul>
      </div>
    )
  }
}

export default NotificationList



// WEBPACK FOOTER //
// ./src/components/shared/header/NotificationList.jsx